import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsAssignmentsSummaryList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsAssignmentSummary/ReportsAssignmentSummaryList"
    )
);
export const ReportsAssignmentsSummary = () => {
  return (
    <Layout>
      <ReportsAssignmentsSummaryList />
    </Layout>
  );
};
